import React, { Component, ReactNode } from 'react';
import { Translation } from 'react-i18next';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('Uncaught error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Translation>
          {(t) => (
            <div className="flex flex-col items-center justify-center min-h-screen gap-[16px] px-[24px] text-center">
              <h1 className="text-[24px] font-display font-bold text-base-black">
                {t('errorBoundary.title')}
              </h1>
              <p className="text-[16px] font-body text-gray-900 max-w-[400px]">
                {t('errorBoundary.message')}
              </p>
              <button
                onClick={() => this.setState({ hasError: false })}
                className="px-[24px] py-[10px] bg-blue-600 text-surface-base rounded-[10px] font-body text-[14px] font-medium hover:bg-blue-900 transition-colors"
              >
                {t('errorBoundary.tryAgain')}
              </button>
            </div>
          )}
        </Translation>
      );
    }

    return this.props.children;
  }
}
